import React, { useContext } from "react";
import bgImage from "../assets/66.png";
import "../styles/ServicesCard.css";
import { LanguageContext } from '../components/LanguageContext';
import translations from '../locales/services.json';

export default function Services() {
    const { language } = useContext(LanguageContext);
    const { title, list } = translations[language].services;

    return (
        <div
            className="services-wrapper"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <section className="services-card">
                <h2 className="services-title">{title}</h2>
                <ul className="services-list">
                    {list.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </section>
        </div>
    );
}
